import {
  Get_Error,
  Get_Markiting_Reports_campaign,
  Important_Marketing_Reports_Type,
  Lead_Preview,
} from '../Types';

const initialState = {
  Campain_Reports: [],
  LeadPreview: [],
  LeadPreviewmarketingreport: [],
  loading: true,
  error: null,
};

const Marketing_Reports_Reducer = (state = initialState, action) => {
  //    console.log("🔥 Reducer Action:", action); // ✅ تحقق مما إذا كان الـ Reducer يُستدعى أم لا

  switch (action.type) {
    case Get_Markiting_Reports_campaign:
      return {
        ...state,
        Campain_Reports: action.payload || [], // ✅ تأكد أن البيانات ليست `undefined`
        loading: false,
      };
    case Lead_Preview:
      return {
        ...state,
        LeadPreview: action.payload || [], // ✅ تأكد أن البيانات ليست `undefined`
        loading: false,
      };

    case Important_Marketing_Reports_Type:
      return {
        ...state,
        LeadPreviewmarketingreport: action.payload || [], // ✅ تأكد أن البيانات ليست `undefined`
        loading: false,
      };

    case Get_Error:
      return {
        ...state,
        error: action.payload || 'Unknown error',
        loading: false,
      };
    default:
      return state;
  }
};
export default Marketing_Reports_Reducer;
